import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../../GramLayouts/index";

import homedata from "../../../gramdata/NavAndFooter";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
  children: {
    [theme.breakpoints.down("md")]: {
      minHeight: "40vh",
    },
  },
}));

const NavAndFooter = (props) => {
  const classes = useStyles();
  const navData = props?.data.data[0];
  const NavLinksData = props?.data.data[1];

  const footerData = props?.data.data[2];

  const NavLayout = layouts[navData?.layout];
  const NavLinksLayout = layouts[NavLinksData?.layout];

  const FooterLayout = layouts[footerData?.layout];

  return (
    <div className={classes.root}>
      <NavLayout data={navData} />
      <NavLinksLayout data={NavLinksData} />

      <div className={classes.children}>{props.children}</div>
      <FooterLayout data={footerData} />
      {/* {props?.data.data?.map((data, index) => {
        const Layout = layouts[data?.layout];
        return <Layout key={index} data={data} />;
      })} */}
    </div>
  );
};
export default NavAndFooter;
